import React, { useEffect, useMemo, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel
} from '@mui/material';
import { DateRangePicker } from '@mui/lab';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer, DatePicker } from 'components';
import L from 'leaflet';
import _ from 'underscore';

import { enqueueSnackbar } from 'actions';
import {
	SetFormState,
	ResetFields,
	GetDatabaseNames,
	GetDatabaseYears,
	GetDatabaseMonths,
	SetSelectedYear,
	SetSelectedMonth,
	DownloadDatabase,
} from './actions/DatasetExportActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const DatasetExport = (props) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));

	const formState = useSelector((state) => state.datasetExportReducer.formState);
	const databases = useSelector((state) => state.datasetExportReducer.databases);
	const years = useSelector((state) => state.datasetExportReducer.years);
	const months = useSelector((state) => state.datasetExportReducer.months);

	const userId = useSelector(state => state.session.user.id);
	// const userOperator = useSelector(state => state.session.user.operator);

	const _handleChangeDatabase = (event) => {
		dispatch(ResetFields());
		dispatch(GetDatabaseYears(event.target.value));
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
				selectedYear: '',
				selectedMonth: ''
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});

		const empty = [];
		dispatch(SetSelectedYear(empty));
		dispatch(SetSelectedMonth(empty));
	};

	const _handleChangeYear = (event) => {
		dispatch(GetDatabaseMonths(formState.values.selectedDatabase, event.target.value));
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
				selectedMonth: ''
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});

		const empty = [];
		dispatch(SetSelectedMonth(empty));
	};

	const _handleChangeMonth = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			isValid: true,
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const _getData = useCallback(() => {
		dispatch(ResetFields());
		dispatch(GetDatabaseNames());
	}, []);

	const _generate = () => {
		dispatch(DownloadDatabase(
			formState.values.selectedDatabase,
			formState.values.selectedMonth,
			formState.values.selectedYear,
			userId));
	};

	useEffect(() => {
		_getData();
	}, [_getData]);

	return (
		<Page className={classes.root} title="Dataset Export">
			<Header module="Modules" view="Dataset Export" />
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardContent>
						<Grid container spacing={2} justifyContent="center">
							<Grid item lg={4} md={4} sm={12} className={classes.item}>
								<SelectField
									id="selectedDatabase"
									name="selectedDatabase"
									hintText="Database"
									defaultValue={formState.values.selectedDatabase || ''}
									menuItems={databases || []}
									onChange={_handleChangeDatabase}
									value={formState.values.selectedDatabase || ''}
								/>
							</Grid>
							<Grid item lg={4} md={4} sm={12} className={classes.item}>
								<SelectField
									id="selectedYear"
									name="selectedYear"
									hintText="Year"
									defaultValue={formState.values.selectedYear || ''}
									menuItems={years || []}
									onChange={_handleChangeYear}
									value={formState.values.selectedYear || ''}
								/>
							</Grid>
							<Grid item lg={4} md={4} sm={12} className={classes.item}>
								<SelectField
									id="selectedMonth"
									name="selectedMonth"
									hintText="Month"
									defaultValue={formState.values.selectedMonth || ''}
									menuItems={months || []}
									onChange={_handleChangeMonth}
									value={formState.values.selectedMonth || ''}
								/>
							</Grid>
							<Grid item lg={4} md={4} sm={12} className={classes.item} />
							<Grid item lg={4} md={4} sm={12} className={classes.item} />
							<Grid item lg={4} md={4} sm={12} className={classes.container} display="flex" justifyContent="flex-end" alignItem="flex-end">
								<Button
									className={classes.generate}
									color="primary"
									onClick={_generate}
									variant="contained"
									size="small"
									disabled={!formState.isValid}
								>
									Download Database
								</Button>
								{/*
								<Button
									className={classes.agreeButton}
									color="primary"
									// onClick={_onCarriersColorsClick}
									variant="contained"
									size="small"
								>
									Export CSV
								</Button>
								*/}
							</Grid>
							{/*
							<Grid item lg={4} md={4} sm={12} className={classes.item} />
							<Grid item lg={4} md={4} sm={12} className={classes.item} />
							*/}
						</Grid>
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default DatasetExport;
